import { motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export const Disclaimer = () => (
  <section className="relative pb-28" data-testid="disclaimer-section">
    <div className="mx-auto max-w-4xl px-6 sm:px-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="rounded-3xl border border-amber-200 bg-amber-50/70 p-8 sm:p-10"
      >
        <p className="flex items-center gap-2 font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-amber-800">
          <ShieldAlert size={13} /> Disclaimer
        </p>
        <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base" data-testid="disclaimer-text">
          We help you cover your knowledge gap, weak concept, and support you build ability to qualify
          the exam. Results may vary from person to person depending upon dedication, time spent on
          practice/remedial flash cards. We will help you in a legit way to qualify. We do not claim
          you by opting to our program you will crack the exam in one go. Though our whole hearted
          effort will be there to see you on the top.
        </p>
      </motion.div>
    </div>
  </section>
);
